<template>
	<div class="ms-photoalbum">
		<Loading v-if="loading" opacity="0.5"/>
		<v-toolbar flat class="header" color="primary" height="60px" style="z-index: 103;">
			<template v-if="!is_selecting_images">
				<v-toolbar-items>
					<v-btn flat dark @click="onClickBack"><v-icon>chevron_left</v-icon></v-btn>
				</v-toolbar-items>
				<v-spacer />
				<v-toolbar-items>
					<v-layout style="align-items: center;">
						<v-flex>
							<h4 class="album-title">アルバム編集</h4>
						</v-flex>
					</v-layout>
				</v-toolbar-items>
				<v-spacer />
				<v-toolbar-items>
					<v-btn flat dark @click="onClickMenu" class="header-menu-button"
						:disabled="(!album || !isAdmin || !hasParent(album))"
					><v-icon>menu</v-icon></v-btn>
					<transition>
						<div class="menu">
							<div class="menu-list-group" v-if="is_menu_opened">
								<v-btn flat block large class="menu-list-item"
									:disabled="!(album && album.items.length > 0)"
									@click="onClickStartSelectingImages"
								>写真を選択</v-btn>
								<v-btn flat block large class="menu-list-item"
									color="#ff5252"
									@click="onClickDeleteAlbum"
								>アルバムを削除</v-btn>
							</div>
						</div>
					</transition>
				</v-toolbar-items>
			</template>
			<template v-else>
				<v-toolbar-items>
					<v-btn flat dark color="white" @click="onClickCancelSelectingImages">キャンセル</v-btn>
				</v-toolbar-items>
				<v-spacer />
				<v-toolbar-items>
					<v-layout style="align-items: center;">
						<v-flex>
							<h4 class="album-title">{{ selected_images.length }}枚を選択中</h4>
						</v-flex>
					</v-layout>
				</v-toolbar-items>
				<v-spacer />
				<v-toolbar-items>
					<v-btn flat dark color="white" @click="onClickSelectAllImages">すべて選択</v-btn>
				</v-toolbar-items>
			</template>
		</v-toolbar>
		<div style="padding-top: 60px; padding-bottom:56px;">
			<div class="pa-2" v-if="hasParent(album)">
				<span>更新日：{{ album.last_modified }}</span><br>
				<v-form ref="form_title" @submit.prevent="onSubmitTitle">
					<v-text-field
						ref="input_title"
						v-model="album.title"
						maxlength="50"
						:rules="[RULES.required, RULES.length_title]"
						:append-outer-icon="is_selecting_images ? undefined : is_title_editing ? 'done' : undefined"
						single-line
						:readonly="!is_title_editing"
						@focus="onFocusTitle"
						@click:append-outer="onClickEditTitle"
					/>
				</v-form>
				<h2>写真</h2>
				<template v-if="album.items.length > 0">
					<v-layout wrap row align-content-start>
						<v-flex v-for="item in album.items" :key="item.id"
							class="pa-1" style="flex: 0 0 auto; position:relative;"
						>
							<div style="cursor: pointer;" @click="onClickImage(item.id)" >
								<v-lazy-image :src="item.thumbnail_uri" style="height: 100px;" />
							</div>
							<v-btn v-if="is_selecting_images" fab
								color="white"
								:outline="!isSelectedImage(item.id)"
								class="btn-image-select"
								@click="onClickToggleSelectImage(item.id)"
								small
							>
								<v-icon v-if="isSelectedImage(item.id)">done</v-icon>
							</v-btn>
						</v-flex>
					</v-layout>
				</template>
				<template v-else>
					<p class="info--text text-xs-center pa-2">
						写真が登録されていません。
					</p>
				</template>
			</div>
		</div>
		<template v-if="hasParent(album)">
			<MSToolbarCamera v-if="!is_selecting_images"
				:resolution="is_camera_resolution_original"
				@change-resolution="onChangeCameraResolution"
				@click-open-file="onClickOpenFile"
				@change-file="onChangeFile"
			/>
			<v-layout class="selecting-menu white" outline v-else>
				<v-flex xs12>
					<v-btn flat block dark color="#ff5252" @click="onClickDeleteSelectedImages">削除</v-btn>
				</v-flex>
			</v-layout>
		</template>
		<GBDialog
			:dialog="dialog" 
			@agree="onClickDialogAgree"
			@disagree="onClickDialogDisagree"
		/>
		<DialogConfirmDeletePhotoAlbum
			:display="dialog_del_album.display"
			@click-cancel="onClickCancelDeleteAlbum"
			@click-confirm="onClickConfirmDeleteAlbum"
		/>
		<DialogConfirmDeletePhotoAlbumItem
				:display="dialog_del_items.display"
				@click-cancel="onClickCancelDeleteImages"
				@click-confirm="onClickConfirmDeleteImages"
		/>
	</div>
</template>
<script>
import Notification from '../../classes/Notification';
import VLazyImage from 'v-lazy-image';
import APIClient from '../../classes/APIClient';
import MouseState from '../../classes/MouseState';
import MouseStateMachine from '../../classes/MouseStateMachine';
import Loading from '../Loading';
import Util from '../../classes/Util';
import uuidv4 from 'uuid/v4';
import ConoHa from '../../classes/ConoHa';
import { IMAGE_MAX_SIZE, PHOTOALBUM_IMAGE_MAX_COUNT, GANTTBOARD_EVENT_ID, DATETIME_FORMAT } from '../../data/Const';
import GBDialog from '../GBDialog';
import MSToolbarCamera from './MSToolbarCamera';
import DialogConfirmDeletePhotoAlbum from './DialogConfirmDeletePhotoAlbum';
import DialogConfirmDeletePhotoAlbumItem from './DialogConfirmDeletePhotoAlbumItem';

const strftime = require('strftime');

const validateLengthTitle = (value) => {
	if (value === undefined || value === null)
		return false;
	if (value.length <= 50)
		return true;

	return false;
};
export default {
	data() {
		const state_default = new MouseState({
			down: (e) => {
				let obj = e.targetTouches ? e.targetTouches[0] : e;
				if(!obj.target.closest('.menu')){
					this.is_menu_opened = false;
				}
			},
		});
		return {
			msm: new MouseStateMachine(state_default),
			api: null,
			conoha: null,
			album: null,
			selected_images: [],
			loading: false,
			is_menu_opened: false,
			is_selecting_images: false,
			is_title_editing: false,
			is_camera_resolution_original: false,
			dialog: {
				display: false,
				title: null,
				text: null,
				disagree: null,
				agree: null,
			},
			dialog_del_album: { display: false },
			dialog_del_items: { display: false },
			RULES: {
				required: v => !!v || '入力してください',
				length_title: v => validateLengthTitle(v) || '50文字以内で入力してください',
			},
			prev_route: null,
		};
	},
	components: {
		Loading,
		VLazyImage,
		GBDialog,
		MSToolbarCamera,
		DialogConfirmDeletePhotoAlbum,
		DialogConfirmDeletePhotoAlbumItem,
	},
	methods: {
		initData: async function(route) {
			this.loading = true;

			this.album = null;
			this.is_selecting_images = false;
			this.selected_images = [];
			this.is_menu_opened = false;
			this.is_selecting_images = false;
			this.is_title_editing = false;
			this.is_camera_resolution_original = false;

			await this.fetch(route.params.contractor_id, route.params.photoalbum_id);

			this.loading = false;
		},
		hasParent: function(album) {
			if (!album)
				return false;

			let project = this.$store.getters.projectList.find(p => p.code === album.project_id);
			if (project) {
				let member = project.members.find(m => m.code === album.member_id);
				if (member) {
					let schedule = member.schedules.find(s => s.code === album.schedule_id);
					if (schedule) {
						return true;
					}
				}
			}

			return false;
		},
		logout: function() {
			this.$store.dispatch('addNotification', Notification.error('もう一度ログインしてください'));
			this.$store.dispatch('logout');
			this.$router.push({name: 'Login', params: { 'contractor_id': this.$route.params.contractor_id }});
		},
		onUpdateDataSet: function() {
			if (!this.album)
				return;
			if (!this.hasParent(this.album)) {
				this.error('案件またはスケジュールが削除されています。');
			}
		},
		onUpdatePhotoAlbum: function(data) {
			if (!this.album)
				return;
			if (data.photoalbum_id !== this.album.id)
				return;
			if (this.is_title_editing)
				return;
			this.$store.dispatch('addNotification', Notification.info('アルバムを同期しました'));
			this.loading = true;
			this.fetch(this.$route.params.contractor_id, this.$route.params.photoalbum_id)
				.then(() => {
					this.loading = false;
				});
		},
		onClickBack: function() {
			let path = [this.$route.params.contractor_id, 'member', this.$route.params.id];
			if (this.album) {
				if (this.hasParent(this.album)) {
					path.push('talkroom', this.album.talkroom_id);
				}
				this.$router.push('/' + path.join('/'));
				return;
			}
			
			if(this.prev_route == null || this.prev_route.name.indexOf('MSTalkRoom') == -1) {
				this.$router.push('/' + path.join('/'));
				return;
			}
			
			this.$router.go(-1);
		},
		onClickMenu: function() {
			if (!this.is_title_editing)
				this.is_menu_opened = !this.is_menu_opened;
			else
				this.$refs.input_title.focus();
		},
		onClickStartSelectingImages: function() {
			this.is_title_editing = false;
			this.is_menu_opened = false;

			this.selected_images = [];
			this.is_selecting_images = true;
		},
		onClickCancelSelectingImages: function() {
			this.is_selecting_images = false;
			this.selected_images = [];
		},
		onClickDeleteAlbum: function() {
			this.is_menu_opened = false;
			this.dialog_del_album.display = true;
		},
		onClickSelectAllImages: function() {
			this.selected_images = this.album.items.map(item => item.id);
		},
		onClickImage: function(id) {
			if (this.is_selecting_images)
				return this.onClickToggleSelectImage(id);

			let uri = '/' + [
				this.$route.params.contractor_id, 'member', this.$route.params.id,
				'photoalbum', this.$route.params.photoalbum_id, 'slideshow',
			].join('/') + '#' + id;
			this.$router.push(uri);
		},
		onClickToggleSelectImage: function(id) {
			let index = this.selected_images.indexOf(id);
			if (index >= 0)
				this.selected_images.splice(index, 1);
			else
				this.selected_images.push(id);
		},
		onClickDeleteSelectedImages: async function() {
			if (this.selected_images.length === 0) {
				this.errorDialog('画像を選択してください');
				return;
			}
			this.dialog_del_items.display = true;
		},
		onFocusTitle: function() {
			if (this.is_selecting_images)
				return;

			this.is_title_editing = true;
		},
		onSubmitTitle: function() {
			if (this.is_title_editing)
				this.onClickEditTitle();
		},
		onClickEditTitle: function() {
			if (!this.is_title_editing)
				return;

			if (!this.$refs.form_title.validate()) {
				return;
			}

			let contractor_id = this.$route.params.contractor_id;
			let photoalbum_id = this.$route.params.photoalbum_id;

			this.updateAlbumTitle(contractor_id, photoalbum_id, this.album)
				.then(() => {
					document.activeElement.blur();
				});
		},
		onClickOpenFile: function(done) {
			if (this.is_title_editing)
				this.$refs.input_title.focus();
			else
				done();
		},
		onChangeCameraResolution: function(original) {
			this.is_camera_resolution_original = original;
		},
		onChangeFile: function(e) {
			let files = e.target.files || e.dataTransfer.files;
			if (files.length === 0)
				return;
			if (PHOTOALBUM_IMAGE_MAX_COUNT < this.album.items.length + files.length) {
				this.errorDialog("登録の上限を超えています。\n[" + PHOTOALBUM_IMAGE_MAX_COUNT + '枚まで]');
				return;
			}

			let contractor_id = this.$route.params.contractor_id;
			let photoalbum_id = this.$route.params.photoalbum_id;
			let failure = [];
			let images = [];
			let items = [];
			let size_list = this.is_camera_resolution_original
				? [
					IMAGE_MAX_SIZE.ORIGINAL,
					IMAGE_MAX_SIZE.THUMBNAIL,
				] : [
					IMAGE_MAX_SIZE.SXGA,
					IMAGE_MAX_SIZE.THUMBNAIL,
				];

			this.loading = true;
			Util.chunkSplitPromiseAll(files, (file) => {
				let name = file.name;
				let type = file.type;
				let item = {
					id: uuidv4(),
					thumbnail_uri: null,
					photo_uri: null,
				};
				let file_id = ['photoalbum', photoalbum_id, item.id].join('/');
				items.push(item);
				return Promise.all(size_list.map(size => {
					return this.conoha.generateImage(file, size)
						.then((res) => {
							images.push({
								'blob': res.blob,
								'src' : res.url,
								'name': size.PREFIX + name,
								'type': type,
								'size': size,
								'id': file_id + size.SUFFIX,
								'setURI': uploaded => {
									if (size === IMAGE_MAX_SIZE.THUMBNAIL)
										item.thumbnail_uri = uploaded.src;
									else
										item.photo_uri = uploaded.src;
								},
							});
						})
						.catch((e) => {
							failure.push(e);
						});
				}));
			})
			.then(() => {
				if (failure.length > 0) {
					this.error("ファイルの読み込みに失敗しました");
					return;
				}
				return this.uploadToConoHa(images)
					.then(async () => {
						await this.appendItems(contractor_id, photoalbum_id, items)
						await this.fetch(contractor_id, photoalbum_id);
					}).catch(() => {
						this.error('画像のアップロードに失敗しました');
					});
			})
			.then(() => {
				this.loading = false;
			});
		},
		onClickDialogDisagree: function() {
			if (this.dialog.disagree)
				this.dialog.disagree();
			return;
		},
		onClickDialogAgree: function() {
			if (this.dialog.agree)
				this.dialog.agree();
			return;
		},
		onClickCancelDeleteAlbum: function() {
			this.dialog_del_album.display = false;
		},
		onClickConfirmDeleteAlbum: function() {
			this.dialog_del_album.display = false;
			this.loading = true;

			let contractor_id = this.$route.params.contractor_id;
			let photoalbum_id = this.$route.params.photoalbum_id;

			this.deleteAlbum(contractor_id, photoalbum_id)
				.then(async () => {
					await this.deleteFromConoHa(this.album.items);
					this.onClickBack();
				})
				.catch(() => {
					this.error('削除に失敗しました');
				})
				.then(() => {
					this.loading = false;
				});
		},
		onClickCancelDeleteImages: function() {
			this.dialog_del_items.display = false;
		},
		onClickConfirmDeleteImages: async function() {
			this.dialog_del_items.display = false;

			let contractor_id = this.$route.params.contractor_id;
			let photoalbum_id = this.$route.params.photoalbum_id;

			let items = this.selected_images.map((id) => {
				return this.album.items.filter(item => item.id === id)[0];
			});
			this.loading = true;
			try {
				await this.deleteItems(contractor_id, photoalbum_id, items)
					.then(async () => {
						await this.fetch(contractor_id, photoalbum_id);
						await this.deleteFromConoHa(items);
						this.onClickCancelSelectingImages();
					})
					.catch(() => {
						this.error('写真の削除に失敗しました');
					});
			} finally {
				this.loading = false;
			}
		},
		onWindowResize: function() {
			Util.onWindowResize();
		},
		uploadToConoHa: async function(images) {
			let uploaded = [];
			let failure = [];
			await Util.chunkSplitPromiseAll(images, async (image) => {
				let headers = {
					'X-Object-Meta-name': encodeURIComponent(image.name),
					'Content-Disposition': 'attachment; filename=' + encodeURIComponent(image.name),
					'Content-Type': image.type,
				};
				try {
					let res = await this.conoha.upload(image.blob, headers, image.id);
					if (image.setURI)
						image.setURI(res);
					uploaded.push(res);
				} catch {
					failure.push(image.name);
				}
			});
			if (failure.length > 0) {
				throw ('upload error');
			}
		},
		deleteFromConoHa: function(items) {
			return Util.chunkSplitPromiseAll(items, async (item) => {
				/* サムネイルは残す */
				// await this.conoha.deleteByURI(item.thumbnail_uri);
				await this.conoha.deleteByURI(item.photo_uri);
			});
		},
		fetch: async function(contractor_id, photoalbum_id) {
			this.album = null;
			return this.api.getPhotoAlbum(photoalbum_id)
				.then(async (res) => {
					let utc = Util.getUTCFromYMDHMS(res.data.last_modified_at);
					this.album = res.data;
					this.album.last_modified = strftime(DATETIME_FORMAT, new Date(utc));

					this.selected_images = this.selected_images.filter(selected => {
						return this.album.items.find(item => item.id == selected);
					});

					if (!this.hasParent(res.data)) {
						this.error('案件、もしくはスケジュールが削除されました');
						return;
					}
					try {
						await this.api.updateBrowseHistory(photoalbum_id);
					} catch {
						// エラー握りつぶす！
					}
				})
				.catch((e) => {
					if (e.token) {
						this.logout();
						return;
					}
					switch (e.response.status) {
					case 404:
						this.error('アルバムが見つかりません');
						break;
					default:
						this.error('アルバムの取得に失敗しました');
					}
				})
		},
		updateAlbumTitle: async function(contractor_id, photoalbum_id, album) {
			this.loading = true;
			return this.api.updatePhotoAlbum(photoalbum_id, {
				'title': album.title,
			})
			.then(async (res) => {
				let utc = Util.getUTCFromYMDHMS(res.data.last_modified_at);
				this.album.title = res.data.title;
				this.album.last_modified = strftime(DATETIME_FORMAT, new Date(utc));
				this.loading = false;
				this.is_title_editing = false;

				try {
					await this.api.updateBrowseHistory(photoalbum_id);
				} catch {
					// エラー握りつぶす！
				}
			})
			.catch((e) => {
				if (e.token) {
					this.logout();
					return;
				}
				this.loading = false;
				switch (e.response.status) {
				case 404:
					this.album = null;
					this.error('アルバムが見つかりません');
					break;
				default:
					this.error('更新に失敗しました');
				}
			});
		},
		appendItems: function(contractor_id, photoalbum_id, items) {
			return this.api.appendPhotoAlbumItems(photoalbum_id, items)
				.catch((e) => {
					if (e.token) {
						this.logout();
						return;
					}
					throw e;
				});
		},
		deleteAlbum: function(contractor_id, photoalbum_id) {
			return this.api.deletePhotoAlbum(photoalbum_id)
				.catch((e) => {
					if (e.token) {
						this.logout();
						return;
					}
					throw e;
				});
		},
		deleteItems: async function(contractor_id, photoalbum_id, items) {
			return this.api.deletePhotoAlbumItems(photoalbum_id, items.map((item) => { return {'id': item.id}}))
				.catch((e) => {
					if (e.token) {
						this.logout();
						return;
					}
					throw e;
				});
		},
		errorDialog: function(text) {
			this.dialog.title = 'エラー';
			this.dialog.text = text;
			this.dialog.disagree = null;
			this.dialog.agree = () => {
				this.dialog.display = false;
				this.dialog.agree = null;
			};
			this.dialog.display = true;
		},
		error: function(text) {
			this.$store.dispatch('addNotification', Notification.error(text));
		},
	},
	computed: {
		isAdmin: function() {
			return this.$store.getters.isAdmin;
		},
		isSelectedImage: function() {
			return (id) => this.selected_images.indexOf(id) >= 0;
		},
	},
	mounted() {
		this.msm.bind(window);
		this.api = new APIClient(this.$store);
		this.conoha = new ConoHa(this.$store.getters.datasetManager);
		this.initData(this.$route);
		this.$store.commit('addGanttBoardEventListener', {
			type: GANTTBOARD_EVENT_ID.PHOTOALBUM_UPDATE,
			listener: this.onUpdatePhotoAlbum,
		});
		this.$store.commit('addGanttBoardEventListener', {
			type: GANTTBOARD_EVENT_ID.DATASET_UPDATE,
			listener: this.onUpdateDataSet,
		});
	},
	created: function() {
		window.addEventListener('resize', this.onWindowResize, false);
		this.onWindowResize();
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.onWindowResize);
		this.msm.unbind();
		this.$store.commit('removeGanttBoardEventListener', {
			type: GANTTBOARD_EVENT_ID.PHOTOALBUM_UPDATE,
			listener: this.onUpdatePhotoAlbum,
		});
		this.$store.commit('removeGanttBoardEventListener', {
			type: GANTTBOARD_EVENT_ID.DATASET_UPDATE,
			listener: this.onUpdateDataSet,
		});
	},
	beforeRouteUpdate(to, from, next) {
		this.initData(to)
			.then(() => {
				next();
			});
	},
	beforeRouteEnter(to, from, next) {
		next( vm => {
			vm.prev_route = from;
		});
	},
};
</script>
<style>
	.ms-photoalbum {
		-moz-user-select: none;
		-webkit-user-select: none;
		-ms-user-select: none;
	}

	.ms-photoalbum .header {
		position: fixed;
		top: 0;
		left: 0;
	}

	.ms-photoalbum .header-menu-button[disabled="disabled"] {
		opacity: 0;
	}

	.ms-photoalbum .menu-list-group {
		top: 46px;
	}

	.ms-photoalbum .album-title {
		color: white;
	}

	.ms-photoalbum .btn-image-select {
		position: absolute;
		top: 5px;
		right: 5px;
	}

	.ms-photoalbum .selecting-menu {
		position: fixed;
		left: 0;
		bottom: 0;
		width: 100%;
		background-color: white;
		border-top: 1px solid;
	}

</style>
